import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { divide, range, minBy } from 'lodash'
import { currency } from 'utils/utils'
import Grid from '@material-ui/core/Grid'
import { TextField } from 'formik-material-ui'
import { Field } from 'formik'
import { useRecoilState } from "recoil";

import { MenuItem } from '@material-ui/core'
import 'react-credit-cards/es/styles-compiled.css'
import useStyles from './style'
import { FormattedMessage } from 'react-intl'
import * as _blackListService from '../../../../service/blacklist-service'
import {unidadeGetResponseState} from "../../../../recoil/atoms/unidadeGetResponseState";
import blockedResourcesSystem from '../../../../utils/blockedResourcesSystem';
import { blockedResourcesEntitiesValues } from '../../../../utils/blockedResourcesEntities'

export default ({ installment, total, items, isNegotiation }) => {
  const installmentValue = installment > 0 ? divide(total, installment) : total
  const classes = useStyles()
  const [viewLock, setViewLock] = useState({})
  const [unidade, setUnidade] = useRecoilState(unidadeGetResponseState)
  const [blockedResources, setBlockedResources] = useState([])
  const [isLoadingBlockedResources, setIsLoadingBlockedResources] = useState(true)

  let numberInstallment = items.length >= 4 ? 11 : ((items.length * 2) + 1)
  
  if (!isNegotiation) {
    const minInstallment = minBy(items, 'maximum_installment_number')
    numberInstallment = minInstallment ? (minInstallment.maximum_installment_number + 1) : 2
  }
  
  useEffect(() => {
    if (unidade && blockedResources && blockedResources.length) {
      const {id: idUnidade} = unidade
      const locksFiltered = blockedResources.filter(r => r?.unidadeId === idUnidade && r.type === blockedResourcesEntitiesValues.Unidade)
      if (locksFiltered) {
        const verifylock = ({ lockName, action, setLock, defaultMessage, selectedYear }) => {
          const lockFound = locksFiltered.find(x => x.action.toLowerCase() === action.toLowerCase())
          if (lockFound) {
            setLock({
              [lockName]: true,
              [`${lockName}Message`]: lockFound?.mensagemBloqueio && lockFound?.mensagemBloqueio !== ''
                ? lockFound?.mensagemBloqueio
                : defaultMessage
            })
          } else {
            setLock({})
          }
        }

        verifylock({
          lockName: 'parcela',
          setLock: setViewLock,
          action: "AcordoParceladoPortal/Unidade",
          defaultMessage: 'Não permite parcelamento',
        })
      }
    }
  }, [unidade, blockedResources])
  
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      if (!blockedResources || !blockedResources.length) {
        await _blackListService.GetBySistemaId(blockedResourcesSystem.SMO).then((response) => {
          if (response && response.length) {
            setBlockedResources(response)
          }
          setIsLoadingBlockedResources(false)
        }).catch(() => {
          setIsLoadingBlockedResources(false)
        })
      }
    }
    fetchPaymentTypes();
  }, [])
  
  if (viewLock?.parcela) return null


  return (
    <>
      <Grid item xs={6} className={classes.item} >
        <Field
          name='installment'
          variant='outlined'
          color='primary'
          id='ckc-mdl-pag-inst'
          fullWidth
          label={<FormattedMessage id='payment-installments-label' />}
          select
          InputLabelProps={{ shrink: true }}
          component={TextField}>
          {range(1, numberInstallment).map(option => (
            <MenuItem key={option} value={option}>
              {option === 0 ? '' : option}
            </MenuItem>
          ))}
        </Field>
      </Grid>
      <Grid item xs={4} className={classNames(classes.root, classes.disabled)}>
        <p><FormattedMessage id='payment-installments-total' values={{ currency: currency(installmentValue) }} /></p>
      </Grid>
    </>
  )
}